import { render, staticRenderFns } from "./orderPay.vue?vue&type=template&id=ccc34d44&scoped=true"
import script from "./orderPay.vue?vue&type=script&lang=js"
export * from "./orderPay.vue?vue&type=script&lang=js"
import style0 from "./orderPay.vue?vue&type=style&index=0&id=ccc34d44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc34d44",
  null
  
)

export default component.exports